import { Component, computed, input, output } from '@angular/core';
import { ButtonSeverity } from 'primeng/button';

type ButtonIconPosition = 'left' | 'right' | 'top' | 'bottom';

@Component({
  selector: 'app-icon-button',
  templateUrl: './icon-button.component.html',
  standalone: false,
})
export class IconButtonComponent {
  icon = input.required<string>();
  size = input<'small' | 'large' | undefined>();
  label = input<string>();
  ariaLabel = input<string>();
  disable = input<boolean>(false);
  loading = input<boolean>(false);
  textColor = input<string | undefined>();
  severity = input<ButtonSeverity>();
  rounded = input<boolean>(false);
  variant = input<'outlined' | 'text' | undefined>();
  iconPos = input<ButtonIconPosition>('left');
  styleClass = input<string>();

  sizePx = computed(() => `${this.size()}px`);

  buttonClass = computed(() => {
    const baseClass = 'rounded-md';
    const additionalClass = this.styleClass();

    return additionalClass ? `${baseClass} ${additionalClass}` : baseClass;
  });

  handleClick = output<MouseEvent>();

  onClick(event: MouseEvent) {
    this.handleClick.emit(event);
  }
}
